export default {"src":"/_next/static/media/Alerts.52fdb482.svg","height":232,"width":413,"blurWidth":0,"blurHeight":0};